import { MOBILE_FULL_WIDTH_DATA_ATTRIBUTE as e } from "./constants/index.mjs";
import { BLOCK_IMAGE_STYLES as t, FIGCAPTION_STYLES as n, FIGURE_CENTERED_STYLES as r, FIGURE_MOBILE_FULL_WIDTH_STYLES as i, getFigureRightStyles as a } from "../../constants/default-styles.mjs";
import { ImageModeEnum as o, ImageNameEnum as s } from "./image-enum.mjs";
import { Image as c } from "./image.mjs";
import { convertStyleObjectToCss as l } from "../../utils/style-helpers.mjs";
import { createCustomImageNodeView as u } from "./custom-image.mjs";
import { getContainerWidthFromElement as d } from "./utils/get-container-width-from-element.mjs";
import { getImageAttrs as f } from "./utils/get-image-attrs.mjs";
import { getImageWithLinkHtml as p } from "./utils/get-image-with-link-html.mjs";
import { mergeAttributes as m } from "@tiptap/react";
//#region src/extensions/image-extension/block-image.ts
var h = c.extend({
	name: s.Block,
	addNodeView() {
		return u(this.options.maxWidth);
	},
	parseHTML() {
		return [{
			tag: "figure:not(.table)",
			getAttrs: (e) => {
				let t = e.querySelector("img"), n = e.querySelector("a"), r = e.querySelector("figcaption"), i = n?.getAttribute("href"), a = f(t), s = d(e), c = e.getAttribute("data-mobile-full-width") === "true" || !!e.closest(".is-mobile-full-width");
				return {
					imageMode: e?.style.float ? o.BlockRight : o.BlockCenter,
					href: i,
					containerWidth: s,
					caption: r?.textContent,
					isMobileFullWidth: c,
					...a
				};
			}
		}];
	},
	renderHTML({ HTMLAttributes: { caption: s, href: c, imageMode: u, alt: d, src: f, title: h, width: g, height: _, containerWidth: v, uploadingProps: y, isMobileFullWidth: b } }) {
		if (y) return ["span", { style: "display: none;" }];
		let x = { ...t };
		g && _ && (x.aspectRatio = `${g}/${_}`), v !== "auto" && (x.width = v);
		let S = m({
			src: f,
			alt: d,
			title: h,
			width: g,
			style: l(x)
		}), C = [p(S, { href: c })];
		s && C.push([
			"figcaption",
			{ style: l(n) },
			s
		]);
		let w = u === o.BlockCenter ? {
			...r,
			...v && { width: v }
		} : {
			...a(!1),
			...v && { width: v }
		}, T = { style: l(w) };
		if (b) {
			let t = [
				"figure",
				{
					...T,
					[e]: "true"
				},
				...C
			];
			return [
				"div",
				[
					"head",
					{},
					[
						"style",
						{ type: "text/css" },
						i
					]
				],
				t
			];
		}
		return [
			"figure",
			T,
			...C
		];
	}
});
//#endregion
export { h as BlockImage };
